import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { triggerSearch } from '../../search';

type TagItemProps = {
  tagItem: string;
  isPresentational: boolean;
};

const TagItem = (props: TagItemProps) => {
  const { tagItem, isPresentational } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClickTag = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isPresentational) {
      e.stopPropagation();
      dispatch(triggerSearch(tagItem));
      navigate(`/search-results?query=${encodeURIComponent(tagItem)}`);
    }
  };

  const tagClass = isPresentational
    ? 'interest-card'
    : 'interest-card clickable';

  return (
    <div key={tagItem} className={tagClass} onClick={handleClickTag}>
      {tagItem}
    </div>
  );
};

export default TagItem;
